import apiService from '../utils/apiService';

import {
  ADD_REQUEST_FOR_SIGNET_STATUS,
  ADD_REQUEST_FOR_SIGNET_STATUS_START,
  ADD_REQUEST_FOR_SIGNET_STATUS_ERROR,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_START,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ERROR,
  VALIDATE_REQUEST_FOR_SIGNET_STATUS,
  VALIDATE_REQUEST_FOR_SIGNET_STATUS_START,
  VALIDATE_REQUEST_FOR_SIGNET_STATUS_ERROR,
} from './types';

import {
  requestForSignetStatusAddPath,
  requestForSignetStatusFindBySignetPath,
  requestForSignetStatusValidPath,
} from '../constants/apiEndpoints';

import { findRequestForSignetStatusAttachmentBySignetId } from './requestForSignetStatusAttachment';
import { createNotification } from '../utils';
import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

const addRequestForSignetStatusStart = () => {
  return {
    type: ADD_REQUEST_FOR_SIGNET_STATUS_START,
  };
};
const addRequestForSignetStatusSuccessfully = (data) => {
  return {
    type: ADD_REQUEST_FOR_SIGNET_STATUS,
    payload: data,
  };
};
const addRequestForSignetStatusUnsuccessfully = (err) => {
  return {
    type: ADD_REQUEST_FOR_SIGNET_STATUS_ERROR,
    payload: err,
  };
};

const validateRequestForSignetStatusStart = () => {
  return {
    type: VALIDATE_REQUEST_FOR_SIGNET_STATUS_START,
  };
};
const validateRequestForSignetStatusSuccessfully = (data) => {
  return {
    type: VALIDATE_REQUEST_FOR_SIGNET_STATUS,
    payload: data,
  };
};
const validateRequestForSignetStatusUnsuccessfully = (err) => {
  return {
    type: VALIDATE_REQUEST_FOR_SIGNET_STATUS_ERROR,
    payload: err,
  };
};

const getRequestForSignetStatusBySignetStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_START,
  };
};
const getRequestForSignetStatusBySignetSuccessfully = (data) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET,
    payload: data,
  };
};
const getRequestForSignetStatusBySignetUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ERROR,
    payload: err,
  };
};

export const createRequestForSignetStatus = (
  requestForSignetStatus,
  callback,
  callback2,
  message,
  callback3
) => {
  return (dispatch) => {
    dispatch(addRequestForSignetStatusStart());
    return apiService
      .post(requestForSignetStatusAddPath(), requestForSignetStatus)
      .then((response) => {
        dispatch(addRequestForSignetStatusSuccessfully(response.data));
        callback();
        callback2();
        callback3();
        createNotification(
          notificationTypeSuccess,
          message.requestForSignetStatus,
          message.successCreateRequestForSignetStatus
        );
      })
      .catch((err) => {
        dispatch(addRequestForSignetStatusUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          message.requestForSignetStatus,
          err?.response?.data?.message
        );
      });
  };
};

export const findRequestForSignetStatusBySignetId = (id) => {
  return (dispatch) => {
    dispatch(getRequestForSignetStatusBySignetStart());
    return apiService
      .get(requestForSignetStatusFindBySignetPath(id))
      .then((response) => {
        dispatch(getRequestForSignetStatusBySignetSuccessfully(response.data));
        response?.data?.id &&
          dispatch(
            findRequestForSignetStatusAttachmentBySignetId(response.data?.id)
          );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetStatusBySignetUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const validateRequestForSignetStatus = (
  requestForSignetStatusId,
  callback,
  message,
  callback2
) => {
  return (dispatch) => {
    dispatch(validateRequestForSignetStatusStart());
    return apiService
      .post(requestForSignetStatusValidPath(requestForSignetStatusId))
      .then((response) => {
        dispatch(validateRequestForSignetStatusSuccessfully(response.data));
        callback();
        callback2();
        createNotification(
          notificationTypeSuccess,
          message.requestForSignetStatus,
          message.successAccepetRequestForSigentStatus
        );
      })
      .catch((err) => {
        dispatch(
          validateRequestForSignetStatusUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          message.requestForSignetStatus,
          err?.response?.data?.message
        );
      });
  };
};
